export default "__VITE_ASSET__4c0cca9f__"